import casualVoronoiPhotoUrl from '../../../assets/casual-cutted-voronoi.png';

/**
 * La cella che ospita la foto del profilo nella variante Voronoi: unica fonte
 * della forma, delle sue dimensioni e della foto che ci sta dentro.
 *
 * Sta in un modulo a parte perche' due componenti diversi ne hanno bisogno e
 * NON devono averne due copie:
 *
 *  - voronoi-header.tsx la disegna, e ci costruisce attorno i semi che fanno
 *    combaciare la tassellazione con il bordo della cella;
 *  - casual-voronoi.tsx la usa per riservare in pagina lo spazio giusto.
 *
 * Prima questi numeri erano duplicati a mano nei due file. Niente se ne
 * accorgeva quando divergevano, e divergendo non si rompeva nulla di evidente:
 * la macchia smetteva solo di combaciare con la foto.
 */

/** Sistema di riferimento locale della cella: il viewBox in cui e' disegnata. */
export const CELL_W = 134.71057;
export const CELL_H = 145.61911;

/**
 * Vertici della cella in coordinate locali, in ordine ciclico.
 *
 * Vincoli, tutti verificati quando sono stati scelti:
 *  1. CONVESSA. Una cella di Voronoi lo e' sempre. Serve anche alla costruzione
 *     dei semi specchiati in voronoi-header.tsx, che su una forma concava non
 *     riprodurrebbe la cella.
 *  2. CONTIENE IL CENTRO del viewBox, (CELL_W/2, CELL_H/2). E' il punto che fa
 *     da seme, e un seme fuori dalla propria cella non ha senso.
 *  3. CONTIENE LA SAGOMA della persona.
 */
export const CELL_LOCAL: [number, number][] = [
  [112.839, 133.351],
  [70.4682, 140.799],
  [23.5928, 145.502],
  [3.95116, 97.1791],
  [-0.300201, 44.7648],
  [58.2331, -0.11754],
  [102.605, 5.86625],
  [129.754, 45.1623],
  [134.41, 100.807],
];

/** Gli stessi vertici nella forma che vuole l'attributo points di un poligono. */
export const CELL_POINTS = CELL_LOCAL.map(([x, y]) => `${x},${y}`).join(' ');

export const casualVoronoiPhoto = casualVoronoiPhotoUrl;
